module.exports = __webpack_public_path__ + "img/eye-mature-1-muscle-fibres.601b33fe.jpg";